import { FilterSection } from './FilterSection';
import { Filters } from '../../types/filters';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface InvestmentTimeFilterProps {
    filters: Filters;
    onFiltersChange: (filters: Filters) => void;
}

export function InvestmentTimeFilter({ filters, onFiltersChange }: InvestmentTimeFilterProps) {
    return (
        <FilterSection title="Investment Time Range" defaultOpen={true}>
            <div className="space-y-3">
                <div className="relative" style={{ zIndex: 40 }}>
                    <DatePicker
                        selectsRange={true}
                        startDate={filters.investmentDateRange[0] ? new Date(filters.investmentDateRange[0]) : undefined}
                        endDate={filters.investmentDateRange[1] ? new Date(filters.investmentDateRange[1]) : undefined}
                        onChange={(dates: [Date | null, Date | null]) => {
                            const [start, end] = dates;
                            onFiltersChange({
                                ...filters,
                                investmentDateRange: [
                                    start ? start.toISOString().split('T')[0] : '',
                                    end ? end.toISOString().split('T')[0] : ''
                                ]
                            });
                        }}
                        isClearable={true}
                        placeholderText="Select date range"
                        className="w-full px-3 py-2 text-sm bg-white border border-gray-200 rounded-md focus:border-indigo-500 focus:outline-none placeholder-gray-400 cursor-pointer"
                        dateFormat="MMM d, yyyy"
                        showPopperArrow={false}
                        popperPlacement="top"
                    />
                </div>
                <div>
                    <label className="flex items-center group cursor-pointer">
                        <input
                            type="checkbox"
                            checked={filters.onlyLeadInvestments || false}
                            onChange={(e) => onFiltersChange({
                                ...filters,
                                onlyLeadInvestments: e.target.checked
                            })}
                            className="w-4 h-4 rounded border-gray-300 text-indigo-500 focus:ring-indigo-500"
                        />
                        <span className="ml-2 text-sm text-gray-600 group-hover:text-gray-900">Only Lead Investments</span>
                    </label>
                </div>
            </div>
        </FilterSection>
    );
} 